import { render, staticRenderFns } from "./optionList.vue?vue&type=template&id=22aeff89&scoped=true&"
import script from "./optionList.vue?vue&type=script&lang=js&"
export * from "./optionList.vue?vue&type=script&lang=js&"
import style0 from "./optionList.vue?vue&type=style&index=0&id=22aeff89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aeff89",
  null
  
)

export default component.exports